/**
 * 支払方法変更_受付登録API
 * レスポンス - レスポンス業務エリア
 */

export interface Sgkd004aResponseDto {
  /** 受付番号 */
  aceptNo?: string;
}
